import React from 'react';
import classnames from 'classnames';

import './styles.scss';

const renderCheckbox = ({ input, name, className }) => {
  const isChecked = input.value ? 'checked' : '';
  return (
    <div className={classnames('CheckBox', className)}>
      <input
        {...input}
        id={name}
        type="checkbox"
        checked={isChecked}
        className="checkbox"
      />
      <label
        htmlFor={name}
        className="label"
        onClick={() => input.onChange(!isChecked)}
      />
    </div>
  );
};

export default renderCheckbox;
